import { useEffect, useRef } from "react";
import { paletteFor } from "./palette";

interface CategoryRailProps {
  categories: { id: number; name: string; itemCount: number }[];
  activeId: number | null;
  onSelect: (id: number) => void;
}

const CategoryRail = ({ categories, activeId, onSelect }: CategoryRailProps) => {
  const railRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (activeId == null || !railRef.current) return;
    const el = railRef.current.querySelector<HTMLElement>(`[data-cat="${activeId}"]`);
    if (!el) return;
    const railLeft = railRef.current.scrollLeft;
    const railWidth = railRef.current.clientWidth;
    const target = el.offsetLeft - 20;
    if (target < railLeft || target > railLeft + railWidth - el.offsetWidth) {
      railRef.current.scrollTo({ left: target, behavior: "smooth" });
    }
  }, [activeId]);

  return (
    <div className="cat-rail-wrap">
      <div className="menu-container">
        <nav className="cat-rail" ref={railRef}>
          <ul>
            {categories.map((c) => {
              const pal = paletteFor(c.name);
              const isActive = c.id === activeId;
              return (
                <li key={c.id}>
                  <button
                    data-cat={c.id}
                    className={"cat-chip " + (isActive ? "is-active" : "")}
                    style={
                      isActive
                        ? {
                            background: pal.primary,
                            borderColor: pal.primary,
                            color: pal.ink,
                          }
                        : undefined
                    }
                    onClick={() => onSelect(c.id)}
                  >
                    <span className="cat-chip__swatch" style={{ background: pal.primary }} />
                    <span className="cat-chip__name">{c.name}</span>
                    <span className="cat-chip__count">{c.itemCount}</span>
                  </button>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default CategoryRail;
